export default {
  refreshFilter: 'networkStatus.refreshFilter',
  validateAndEmitFilters: 'networkStatus.validateAndEmitFilters',
};
